export const COLLECTION_ADMINISTRATION_CODES = {
    COLLECTION_ADMINISTRATION_MODULE: 'FEAT-490',
    COLLECTION_ADMINISTRATION_NEW_TEMPLATE: 'FEAT-491',
    COLLECTION_ADMINISTRATION_TEMPLATE_LOGS: 'FEAT-492',
    COLLECTION_ADMINISTRATION_ENABLE_DISABLE_TEMPLATE: 'FEAT-493',
    COLLECTION_ADMINISTRATION_UPDATE_TEMPLATE: 'FEAT-494',
    COLLECTION_ADMINISTRATION_PAYMENTS_HISTORY: 'FEAT-495',
    COLLECTION_ADMINISTRATION_DELETE_TEMPLATE: 'FEAT-496',
    COLLECTION_ADMINISTRATION_DETAIL_TEMPLATE_LOGS: 'FEAT-497',
    COLLECTION_ADMINISTRATION_CHECK_DETAIL_PAYMENT: 'FEAT-498',
    COLLECTION_ADMINISTRATION_CHECK_LOGS_HISTORY_COLLECTION: 'FEAT-499',
    COLLECTION_ADMINISTRATION_DELETE_COLLECTION: 'FEAT-500',
    COLLECTION_ADMINISTRATION_EXPORT_DEBTORS_INFO: 'FEAT-501',
    COLLECTION_ADMINISTRATION_CHECK_LOGS_DETAIL_COLLECTION: 'FEAT-502',
    COLLECTION_ADMINISTRATION_EXONERATE_DEBTOR: 'FEAT-503',
    COLLECTION_ADMINISTRATION_UPDATE_DEBTOR: 'FEAT-504',
    COLLECTION_ADMINISTRATION_CREATE_PAYMENT_EXTRAORDINARY: 'FEAT-505',
    COLLECTION_ADMINISTRATION_CHECK_PAYMENT_COMPROBANT: 'FEAT-506',
}

export const COLLECTION_ADMINISTRATION_CODES_NAMES = {
    COLLECTION_ADMINISTRATION_MODULE: 'COLLECTION_ADMINISTRATION_MODULE',
    COLLECTION_ADMINISTRATION_NEW_TEMPLATE: 'COLLECTION_ADMINISTRATION_NEW_TEMPLATE',
    COLLECTION_ADMINISTRATION_TEMPLATE_LOGS: 'COLLECTION_ADMINISTRATION_TEMPLATE_LOGS',
    COLLECTION_ADMINISTRATION_ENABLE_DISABLE_TEMPLATE: 'COLLECTION_ADMINISTRATION_ENABLE_DISABLE_TEMPLATE',
    COLLECTION_ADMINISTRATION_UPDATE_TEMPLATE: 'COLLECTION_ADMINISTRATION_UPDATE_TEMPLATE',
    COLLECTION_ADMINISTRATION_DELETE_TEMPLATE: 'COLLECTION_ADMINISTRATION_DELETE_TEMPLATE',
    COLLECTION_ADMINISTRATION_PAYMENTS_HISTORY: 'COLLECTION_ADMINISTRATION_PAYMENTS_HISTORY',
    COLLECTION_ADMINISTRATION_DETAIL_TEMPLATE_LOGS: 'COLLECTION_ADMINISTRATION_DETAIL_TEMPLATE_LOGS',
    COLLECTION_ADMINISTRATION_CHECK_DETAIL_PAYMENT: 'COLLECTION_ADMINISTRATION_CHECK_DETAIL_PAYMENT',
    COLLECTION_ADMINISTRATION_CHECK_LOGS_HISTORY_COLLECTION: 'COLLECTION_ADMINISTRATION_CHECK_LOGS_HISTORY_COLLECTION',
    COLLECTION_ADMINISTRATION_DELETE_COLLECTION: 'COLLECTION_ADMINISTRATION_DELETE_COLLECTION',
    COLLECTION_ADMINISTRATION_EXPORT_DEBTORS_INFO: 'COLLECTION_ADMINISTRATION_EXPORT_DEBTORS_INFO',
    COLLECTION_ADMINISTRATION_CHECK_LOGS_DETAIL_COLLECTION: 'COLLECTION_ADMINISTRATION_CHECK_LOGS_DETAIL_COLLECTION',
    COLLECTION_ADMINISTRATION_EXONERATE_DEBTOR: 'COLLECTION_ADMINISTRATION_EXONERATE_DEBTOR',
    COLLECTION_ADMINISTRATION_UPDATE_DEBTOR: 'COLLECTION_ADMINISTRATION_UPDATE_DEBTOR',
    COLLECTION_ADMINISTRATION_CREATE_PAYMENT_EXTRAORDINARY: 'COLLECTION_ADMINISTRATION_ECREATE_PAYMENT_EXTRAORDINARY',
    COLLECTION_ADMINISTRATION_CHECK_PAYMENT_COMPROBANT: 'COLLECTION_ADMINISTRATION_CHECK_PAYMENT_COMPROBANT',
}